// extracted by mini-css-extract-plugin
module.exports = {"suggestedEditsTable":"styles__suggestedEditsTable___39WBH","stationLink":"styles__stationLink___3oM_4"};